import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MandatoryTemplateApi } from '../api/mandatory-template.api';
import { switchMap, map } from 'rxjs/operators';

import { MandatoryTemplateData, MandatoryTemplate } from '../../../interfaces/masters/mandatory-template' ;
@Injectable()
export class MandatoryTemplateService extends MandatoryTemplateData {

    constructor(private api: MandatoryTemplateApi) {
      super();
    }
  
  
    list(url: string): Observable<MandatoryTemplate[]> {
      return this.api.list(url);
    }
    update(url: string, data:MandatoryTemplate[]): Observable<any> {
      return this.api.update(url,data);
    }
     create(url: string, data:MandatoryTemplate[]): Observable<MandatoryTemplate> {
      return this.api.add(url,data);
    }

  }
  